import moment from "moment";
import ClearIcon from '@mui/icons-material/Clear';
import { exportToCSV, getStateOfPoll } from "../../helpers/utils";
import SweetAlert from "../SweetAlert/SweetAlert"
import Swal from 'sweetalert2';
import { archiveContest, deleteContest, stopContest, exportContestParticipants, openContestParticipantModel, startContest, endAndGenerateWinner, exportContestWinners, openContestWinnerModel, getContestById, openOptionalInfoModel } from "../../store/slices/contestSlice";
import { useDispatch, useSelector } from "react-redux";
import PollCell from "./PollCell";
import ElapsedTime from "../ElapsedTime/ElapsedTime";
import { Modal, Spinner } from "react-bootstrap";
import { useState } from "react";
import { useSocket } from "./../../context/SocketContext";
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';
import OptionalInfoModel from "../models/OptionalInfoModel";

const ContestCell = ({ contest, setUpdateContestModel }) => {

    const dispatch = useDispatch();
    const { isArchiving, isUpdating } = useSelector((state) => state.contest);
    const auth = useSelector((state) => state.auth);
    const { socket } = useSocket();

    const roomId = auth?.user?.attributes?.stationChatId;

    const started = contest.attributes.state == 1;
    const archived = contest.attributes.state == 4;
    const stopped = contest.attributes.state == 2 || contest.attributes.state == 3;
    const isWinnerGenerated = contest.attributes.meta?.winners?.length ? true : false;
    const [isLoading, setIsLoading] = useState(false);
    const [isWinnerGenerating, setIsWinnerGenerating] = useState(false);
    const [isWinnerExporting, setIsWinnerExporting] = useState(false);
    const [showMediaModal, setShowMediaModal] = useState(false);
    const { isScheduled, tz, displayData, image, description } = contest.attributes;
    const scheduledData = displayData ? JSON.parse(displayData) : {};

    // checking on the basis of has question or without question
    const totalVotesCount = contest?.attributes?.votesCount || contest?.relations.users.data.length;

    // Check if we have content to show in modal
    const hasImage = image && image.trim() !== '';
    const hasDescription = description && description.trim() !== '';
    const hasMediaContent = hasImage || hasDescription;

    const archiveContestAction = async () => {
        try {
            await dispatch(archiveContest({ id: contest.id })).unwrap(); // unwrap ensures it's a success
            socket.emit('poll.contest.archived', { contest, roomId });
        } catch (error) {
            console.error('Error archiving Contest:', error);
        }
    };

    const stopContestAction = async () => {
        try {
            await dispatch(stopContest({ id: contest.id })).unwrap();
            socket.emit('poll.contest.stoped', { contest, roomId });
        } catch (error) {
            console.error('Error stopping Contest:', error);
        }
    };

    const startContestAction = async () => {
        try {
            await dispatch(startContest({ id: contest.id })).unwrap();
            socket.emit('poll.contest.started', { contest, roomId });
        } catch (error) {
            console.error('Error starting Contest:', error);
        }
    };

    const exportUsers = () => {
        setIsLoading(true);
        dispatch(exportContestParticipants({ id: contest.id }))
            .unwrap()
            .then(response => exportToCSV(response, `Users_${contest.attributes.prize}`))
            .finally(() => setIsLoading(false));
    };

    const exportWinners = () => {
        setIsWinnerExporting(true);
        dispatch(exportContestWinners({ id: contest.id }))
            .unwrap()
            .then(response => exportToCSV(response, `Winners_${contest.attributes.prize}`))
            .finally(() => setIsWinnerExporting(false));
    };

    const openWinnerModel = () => {
        dispatch(openContestWinnerModel({ id: contest.id }));
    }

    const endContest = async () => {
        try {
            await dispatch(endAndGenerateWinner({ id: contest.id })).unwrap();
            socket.emit(`poll.contest.ended`, { contest, roomId });
        } catch (error) {
            console.error('Error starting poll:', error);
        }
    };

    const deleteAction = async () => {
        try {
            if (started) {
                Swal.fire("Not Allowed!", "This contest is active. Please stop it before deleting.", "error");
                return false;
            }

            SweetAlert({
                title: "Delete Contest",
                text: 'Do you want to erase this contest permanently?',
                showSuccessAlert: false,
                confirmAction: async () => {
                    Swal.showLoading();
                    await dispatch(deleteContest({ id: contest.id })).unwrap()
                    socket.emit(`poll.contest.delete`, { contest, roomId });

                }
            });
        } catch (error) {
            console.log(error)
        }
    }

    const openModel = () => {
        dispatch(openContestParticipantModel({ id: contest.id }));
    }

    return (
        <>
            <div className="poll-cell border">
                <div className="pb-2">
                    <div className="top-section">
                        <div className="header-section">
                            <span className="question-heading text-wrap">{contest.attributes.prize}</span>
                            <span className="status">status: {getStateOfPoll(contest.attributes.state)}</span>
                        </div>
                        <div className="d-flex">
                            {/* Info button for media content */}
                            {hasMediaContent && (
                                <button
                                    className="dull-button me-2" style={{ right: "66px" }}
                                    onClick={() => dispatch(openOptionalInfoModel({image, description})) }
                                    title="Show optional Information"
                                >
                                    <InfoIcon />
                                </button>
                            )}
                            <button className="dull-button me-2" style={{ right: "30px" }} onClick={
                                () => {
                                    dispatch(getContestById({ id: contest.id }));
                                    setUpdateContestModel(true)
                                }
                            }>
                                {!archived && <EditIcon />}
                            </button>
                            <button className="dull-button" onClick={deleteAction}><ClearIcon /></button>
                        </div>
                    </div>

                    <div className="answer-section pb-1">
                        <p className="f-11 mb-0">Number of Winners To Be Selected</p>
                        <p className="f-12"><strong>{contest.attributes.nWinners}</strong></p>
                        <p className="f-11 mb-0">Total Votes</p>
                        <p className="f-12"><strong>{totalVotesCount}</strong></p>

                        {contest?.attributes?.hasQuestions
                            ?
                            <PollCell key={contest?.id + '_' + contest?.relations?.poll?.data?.id} poll={contest?.relations?.poll?.data} votesCount={totalVotesCount} contest={contest} />
                            : ''}

                        {archived !== true && stopped !== true && (isScheduled == 1 || isScheduled == 2) && < div style={{ textAlign: 'left', border: '1px solid lightgray' }} className="p-3 mb-3">
                            {isScheduled == 1 && !started &&
                                <div>
                                    <div style={{ fontSize: '12px' }}>
                                        <p>
                                            <strong>Contest is Scheduled :</strong>
                                        </p>
                                        <table style={{ width: '100%' }}>
                                            <tr>
                                                <td>Start Time: </td>
                                                <td>{scheduledData.startDate} {scheduledData.startTime} ({tz})</td>
                                            </tr>
                                            <tr>
                                                <td>End Time: </td>
                                                <td>{scheduledData.endDate} {scheduledData.endTime} ({tz})</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>}

                            {isScheduled == 2 && started &&
                                <div>
                                    <div style={{ fontSize: '12px' }}>
                                        <p>
                                            <strong>Contest is Scheduled :</strong>
                                        </p>
                                        <table style={{ width: '100%' }}>
                                            <tr>
                                                <td>End Time: </td>
                                                <td>{scheduledData.endDate} {scheduledData.endTime} ({tz})</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>}

                        </div>}

                        {contest?.attributes?.startedAt && (<>
                            <p className="f-11 mb-0">Start Time</p>
                            <p className="f-12"><strong className="text-danger">{moment(contest?.attributes?.startedAt).format("YYYY-MM-DD hh:mm a")}</strong></p>
                            <p className="f-11 mb-0">Elapsed Time</p>
                            <p className="f-12">
                                <ElapsedTime startTime={contest?.attributes?.startedAt} />
                            </p>
                        </>)}

                    </div>
                    <div className="footer-section pb-2">
                        <div className="d-flex justify-content-end gap-2">
                            {!contest?.attributes?.hasQuestions ?
                                (<>
                                    {<button
                                        className='btn btn-md  btn-dark'
                                        onClick={() => exportUsers()}
                                        disabled={(totalVotesCount > 0) ? false : true}
                                    >
                                        {isLoading ? (
                                            <>
                                                <Spinner animation="border" size="sm" className="me-1" /> Exporting Participant(s)
                                            </>
                                        ) : "Export Participant(s)"}
                                    </button>}
                                    {isWinnerGenerated && totalVotesCount > 0 &&
                                        <button
                                            className='btn btn-md btn-success'
                                            onClick={() => exportWinners()}
                                            disabled={(isWinnerExporting) ? true : false}
                                        >
                                            {isWinnerExporting ? (
                                                <>
                                                    <Spinner animation="border" size="sm" className="me-1" /> Exporting Winner(s)
                                                </>
                                            ) : "Export Winner(s)"}
                                        </button>
                                    }

                                    {/* show generate winners button if the winner is not genrated yet plus their are few votes on the contest */}

                                    {!isWinnerGenerated && totalVotesCount > 0 && <button className='btn btn-md btn-success'
                                        disabled={(totalVotesCount == 0 && isWinnerGenerating || !stopped) ? true : false}
                                        onClick={() => {
                                            endContest();
                                        }}>{isWinnerGenerating ? (
                                            <span className="d-flex gap-3">
                                                Generating...
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

                                            </span>
                                        ) : 'Generate Winner(s)'}</button>
                                    }

                                    {isWinnerGenerated && totalVotesCount > 0 && <button className='btn btn-md btn-success'
                                        onClick={() => {
                                            openWinnerModel();
                                        }}>Winner(s)</button>
                                    }
                                    {<button className='btn btn-sm f-11 btn-primary py-1'
                                        disabled={(totalVotesCount == 0) ? true : false}
                                        onClick={() => {
                                            openModel();
                                        }}>Participant(s)</button>}

                                </>
                                ) : (isWinnerGenerated && totalVotesCount > 0 && (

                                    <>
                                        <button
                                            className='btn btn-md btn-success'
                                            onClick={openWinnerModel}
                                        >
                                            Winner(s)
                                        </button>

                                        <button
                                            className='btn btn-md btn-success'
                                            onClick={exportWinners}
                                        >
                                            {isWinnerExporting ? (
                                                <>
                                                    <Spinner animation="border" size="sm" className="me-1" />
                                                    Exporting Winner(s)
                                                </>
                                            ) : (
                                                "Export Winner(s)"
                                            )}
                                        </button>
                                    </>
                                )
                                )
                            }


                            {!isWinnerGenerated && !archived && <button
                                className="btn btn-dark"
                                disabled={isUpdating === 0}
                                onClick={started ? stopContestAction : startContestAction}
                            >
                                {isUpdating ? (
                                    <span className="">
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Wait...
                                    </span>
                                ) : started ? (
                                    'Stop'
                                ) : stopped ? (
                                    'Resume'
                                ) : isScheduled ? (
                                    'Start Now'
                                ) : (
                                    'Start'
                                )}
                            </button>}
                            {(!archived) && (
                                < >
                                    <button
                                        disabled={isArchiving === 0}
                                        className="btn btn-outline-secondary"
                                        onClick={archiveContestAction}
                                    >
                                        {isArchiving ? (
                                            <span className="">
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                Wait...
                                            </span>
                                        ) : 'Archive'}
                                    </button>
                                </>
                            )}
                        </div>

                    </div>

                </div>
            </div>

        </>
    )
};

export default ContestCell;